import React from "react";

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { error: null };
    }

    static getDerivedStateFromError(error) {
        return { error };
    }

    componentDidCatch(error, info) {
        console.error("ErrorBoundary caught:", error, info);
    }

    render() {
        if (this.state.error) {
            return (
                <div style={{ padding: 24, fontFamily: "monospace" }}>
                    <h3>Something went wrong rendering this view.</h3>
                    <pre style={{ whiteSpace: "pre-wrap", color: "#a00" }}>
                        {String(this.state.error && this.state.error.message)}
                    </pre>
                    <button onClick={() => this.setState({ error: null })}>Try again</button>
                </div>
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
